module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "tips",
    class: _vm.color
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n    "), _c('i', {
    staticClass: "glyphicon glyphicon-remove",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b409c680!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widget/tips/tips.vue
// module id = 452
// module chunks = 2